import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './baseQuery'

export const activityLogApi = createApi({
  reducerPath: 'activityLogApi',
  baseQuery: authenticatedBaseQuery,
  endpoints: (builder) => ({
    getActivityLog: builder.query({
      query: () => 'user/activity-log/',
    }),
  }),
})

export const { useGetActivityLogQuery } = activityLogApi
